<template>
    <span
        v-if="temDetalhamento()"
    >
        <span class="text-primary ml-1">
            <i
                class="fa fa-list fa-lg icon-button"
                title="Detalhe da Aprovação Justificada"
                @click.stop="mostrarDetalhamento()"
            ></i>
        </span>
        <b-modal
            id="modalDetalheReprovacao"
            v-model="mostrarModal"
            size="lg"
            hide-footer
        >
            <div slot="modal-title">
                {{ tituloModal }}
            </div>
            <b-card :no-body="true">
                <b-card-body>
                    <b-col v-for="chave in chaveLista" :key="chave">
                        <b-row class="border-bottom"
                            style="
                                align-items: center;
                                display: flex;
                                padding-top: 5px;
                                padding-bottom: 5px;"
                        >
                            <b-col
                                style="margin-bottom: 0px;"
                                sm="12"
                                :md="md"
                                :lg="lg"
                                :xl="xl"
                                class="p-0"
                            >
                                <span>
                                    <span
                                        :class="{ 
                                            'p-0': $mq != 'sm' && $mq != 'md',
                                            'h5': $mq != 'sm' && $mq != 'md'
                                        }"
                                    >
                                        {{ chave }}
                                    </span>
                                </span>
                            </b-col>
                            <b-col
                                sm="12"
                                :md="mddiff"
                                :lg="lgdiff"
                                :xl="xldiff"
                                :class="{ 
                                    'p-0': $mq != 'sm' && $mq != 'md', 
                                    'h5': $mq != 'sm' && $mq != 'md',
                                }"
                                style="
                                    margin-bottom: 0px;
                                    align-items: end;
                                "
                            >   
                                <span>
                                    <strong>
                                        {{ obterDado(chave) }}
                                    </strong>
                                </span>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-card-body>
            </b-card>
        </b-modal>
    </span>
</template>

<script>
export default {
    props: {
        chave: {
            type: String,
            default: () => ({})
        },
        dados: {
            type: Object,
            default: () => ({})
        },
        md: {
            type: Number,
            default: () => 11
        },
        lg: {
            type: Number,
            default: () => 11
        },
        xl: {
            type: Number,
            default: () => 11
        }
    },

    data() {
        return {
            mostrarModal: false
        }
    },

    methods: {
        mostrarDetalhamento() {
            this.mostrarModal = true
        },

        fecharDetalhamento() {
            this.mostrarModal = false
        },

        temDetalhamento() {
            return ['totalAprovadasUABS', 'totalReprovadasUABS'].includes(this.chave)
                && Object.keys(this.dadosDetalhamento).length != 0
        },

        obterDado(chave) {
            return this.dadosDetalhamento[chave]
        },
    },

    computed: {
        tituloModal() {
            switch (this.chave) {
                case 'totalAprovadasUABS':
                    return 'Detalhamento - Aprovações da UABS'
                
                case 'totalReprovadasUABS':
                    return 'Detalhamento - Reprovações da UABS'
            
                default:
                    return 'Detalhamento'
            }
        },

        contextoQuadro() {
            switch (this.chave) {
                case 'totalAprovadasUABS':
                    return 'qtdAprovacaoJustificadaUABS'
                
                case 'totalReprovadasUABS':
                    return 'qtdReprovacaoUABS'
            
                default:
                    return null
            }
        },

        dadosDetalhamento() {
            return this.dados[this.contextoQuadro]
        },

        chaveLista() {
            return Object.keys(this.dadosDetalhamento)
        },

        mddiff() {
            return 12 - this.md
        },

        lgdiff() {
            return 12 - this.lg
        },

        xldiff() {
            return 12 - this.xl
        }
    }
}
</script>
